import { BoardIconProps, ColorBoardIconProps } from '@/helpers/utils'

export const RemoteIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
      <path className='st1' fill='#FFFFFF' d='M16.2,13.06' />
      <path
        className='st2'
        fill='#FFFFFF'
        d='M20.7,13.34c0.82-0.23,1.3-1.06,1.07-1.87c-0.23-0.8-1.08-1.27-1.9-1.05l-6.18,1.71l-2.95-3.25
	C10.17,8.26,9.2,8.21,8.56,8.76c-0.64,0.56-0.69,1.51-0.13,2.14l2.93,3.24l-2.44,5.85c-0.32,0.77,0.06,1.66,0.84,1.97
	c0.19,0.08,0.39,0.11,0.58,0.11c0.61,0,1.18-0.36,1.43-0.94l1.86-4.48l2.5,2.76c-0.63,0.56-0.69,1.51-0.12,2.13
	c0.3,0.34,0.73,0.51,1.15,0.51c0.36,0,0.73-0.13,1.02-0.38l2.3-2.01c0.64-0.56,0.69-1.51,0.13-2.14c-0.56-0.62-1.54-0.68-2.17-0.13
	l-2.49-2.74L20.7,13.34z'
      />
    </g>
  </svg>
)

export const ContractIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M21.28,13.84H8.96c-1.31,0-2.37-1.06-2.37-2.37S7.65,9.1,8.96,9.1h12.33c1.31,0,2.37,1.06,2.37,2.37
		S22.59,13.84,21.28,13.84z'
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M16.22,21.18H8.96c-1.31,0-2.37-1.06-2.37-2.37s1.06-2.37,2.37-2.37h7.26c1.31,0,2.37,1.06,2.37,2.37
		S17.53,21.18,16.22,21.18z'
      />
    </g>
  </svg>
)

export const LocationIcon = ({
  color = '#C5C5C5',
  width = 30,
  height = 30,
  className,
}: ColorBoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle className='st0' cx='15' cy='15' r='15' fill={color} />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M20.43,13.1c0-2.94-2.43-5.32-5.43-5.32c-3,0-5.43,2.38-5.43,5.32c-0.03,4.11,5.42,9.4,5.42,9.4
		s4.33-4.2,5.25-8.03C20.36,14.04,20.43,13.58,20.43,13.1 M15,11.29c1.02,0,1.84,0.81,1.84,1.81c0,1-0.83,1.81-1.84,1.81
		c-1.02,0-1.84-0.81-1.84-1.81C13.16,12.1,13.98,11.29,15,11.29'
      />
    </g>
  </svg>
)
export const VacationIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <circle
      className='st0'
      cx='15'
      cy='15'
      r='15'
      fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
    />
    <g>
      <path
        className='st1'
        fill='#FFFFFF'
        d='M22.48,18.25c-0.06-0.09-0.16-0.14-0.27-0.15L7.83,17.31c-0.12,0-0.24,0.05-0.31,0.15
			c-0.07,0.1-0.09,0.23-0.04,0.35l1.34,3.2c0.06,0.13,0.19,0.22,0.33,0.22H21.6c0.17,0,0.31-0.11,0.35-0.27l0.59-2.41
			C22.57,18.45,22.54,18.34,22.48,18.25z'
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M20.97,16.01l-6.03-8.54c-0.06-0.09-0.17-0.13-0.27-0.14c-0.11,0-0.21,0.05-0.27,0.14l-5.35,7.92
			c-0.07,0.1-0.07,0.22-0.02,0.33c0.05,0.11,0.16,0.17,0.28,0.18l5.35,0.29l6.03,0.33c0.01,0,0.01,0,0.02,0
			c0.12,0,0.23-0.06,0.29-0.17C21.05,16.24,21.05,16.11,20.97,16.01z'
      />
    </g>
  </svg>
)

export const ExpiredIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M20.5,9.7h-0.6V8.5c0-0.5-0.4-0.9-0.9-0.9S18.1,8,18.1,8.5v1.2h-6.2V8.5c0-0.5-0.4-0.9-0.9-0.9S10.1,8,10.1,8.5
	v1.2H9.5c-0.9,0-1.7,0.8-1.7,1.7v8.3c0,0.9,0.8,1.7,1.7,1.7h10.9c0.9,0,1.7-0.8,1.7-1.7v-8.3C22.2,10.5,21.4,9.7,20.5,9.7z
	 M17.8,17.1c0.4,0.4,0.4,0.9,0,1.3c-0.2,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.5-0.1-0.7-0.3L15,16.9l-1.5,1.5c-0.2,0.2-0.4,0.3-0.7,0.3
	c-0.2,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-0.9,0-1.3l1.5-1.5l-1.5-1.5c-0.4-0.4-0.4-0.9,0-1.3c0.4-0.4,0.9-0.4,1.3,0l1.5,1.5l1.5-1.5
	c0.4-0.4,0.9-0.4,1.3,0c0.4,0.4,0.4,0.9,0,1.3l-1.5,1.5L17.8,17.1z'
      />
    </g>
  </svg>
)

export const EndTimeIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M20.5,9.7h-0.6V8.5c0-0.5-0.4-0.9-0.9-0.9S18.1,8,18.1,8.5v1.2h-6.2V8.5c0-0.5-0.4-0.9-0.9-0.9S10.1,8,10.1,8.5
	v1.2H9.5c-0.9,0-1.7,0.8-1.7,1.7v8.3c0,0.9,0.8,1.7,1.7,1.7h10.9c0.9,0,1.7-0.8,1.7-1.7v-8.3C22.2,10.5,21.4,9.7,20.5,9.7z
	 M11.3,18.7c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3S12,18.7,11.3,18.7z M11.3,15c-0.7,0-1.3-0.6-1.3-1.3
	c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C12.5,14.5,12,15,11.3,15z M15,18.7c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3
	s1.3,0.6,1.3,1.3S15.7,18.7,15,18.7z M15,15c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3C16.3,14.5,15.7,15,15,15
	z M18.8,15c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3C20,14.5,19.5,15,18.8,15z'
      />
    </g>
  </svg>
)
export const ExperienceIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
      <g>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M19.13,21.6c-0.08-0.03-0.22-0.08-0.35-0.15c-0.92-0.48-1.84-0.97-2.77-1.45c-0.67-0.35-1.35-0.35-2.02,0
			c-0.93,0.48-1.86,0.97-2.79,1.46c-0.21,0.11-0.44,0.24-0.67,0.07c-0.23-0.17-0.17-0.42-0.13-0.66c0.18-1.04,0.36-2.08,0.53-3.12
			c0.12-0.71-0.08-1.34-0.59-1.85c-0.73-0.74-1.49-1.46-2.23-2.18c-0.08-0.08-0.16-0.15-0.22-0.24c-0.24-0.31-0.14-0.62,0.24-0.71
			c0.27-0.07,0.55-0.1,0.83-0.14c0.84-0.12,1.68-0.24,2.51-0.36c0.73-0.11,1.29-0.5,1.62-1.17c0.47-0.93,0.92-1.87,1.39-2.8
			C14.6,8.08,14.7,7.81,15,7.82c0.3,0,0.4,0.27,0.51,0.5c0.46,0.93,0.92,1.87,1.39,2.8c0.34,0.66,0.89,1.05,1.63,1.16
			c1.04,0.15,2.08,0.3,3.11,0.45c0.23,0.03,0.48,0.06,0.57,0.33c0.09,0.27-0.1,0.45-0.27,0.61c-0.74,0.73-1.49,1.45-2.24,2.18
			c-0.55,0.54-0.76,1.2-0.63,1.96c0.17,1,0.35,2.01,0.51,3.01c0.03,0.15,0.04,0.32,0.02,0.47C19.57,21.51,19.42,21.61,19.13,21.6z'
        />
      </g>
    </g>
  </svg>
)
export const RelocationIcon = ({
  width = 30,
  height = 30,
  color = '#C5C5C5',
  className,
}: ColorBoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle className='st0' cx='15' cy='15' r='15' fill={color} />
      <g>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M13.69,10.89h-2.42l0.97-0.87c0.54-0.48,0.59-1.31,0.1-1.85c-0.48-0.54-1.31-0.59-1.85-0.1l-3.53,3.16
			c-0.01,0.01-0.01,0.02-0.02,0.02c-0.02,0.02-0.04,0.04-0.05,0.05c-0.01,0.01-0.03,0.03-0.04,0.04c-0.02,0.02-0.03,0.04-0.05,0.06
			c-0.01,0.01-0.02,0.03-0.03,0.04c-0.02,0.02-0.03,0.05-0.05,0.07c-0.01,0.01-0.02,0.03-0.02,0.04c-0.02,0.03-0.03,0.06-0.04,0.08
			c-0.01,0.01-0.01,0.02-0.02,0.03c-0.01,0.03-0.03,0.06-0.04,0.1c0,0.01-0.01,0.02-0.01,0.03c-0.01,0.04-0.02,0.07-0.03,0.11
			c0,0.01,0,0.01-0.01,0.02c-0.01,0.04-0.01,0.08-0.02,0.12c0,0.01,0,0.01,0,0.02c0,0.05-0.01,0.09-0.01,0.14
			c0,0.05,0,0.09,0.01,0.14c0,0.01,0,0.01,0,0.02c0,0.04,0.01,0.08,0.02,0.12c0,0.01,0,0.01,0.01,0.02
			c0.01,0.04,0.02,0.07,0.03,0.11c0,0.01,0.01,0.02,0.01,0.03c0.01,0.03,0.02,0.06,0.04,0.1c0.01,0.01,0.01,0.02,0.02,0.04
			c0.01,0.03,0.03,0.06,0.04,0.08c0.01,0.01,0.02,0.03,0.03,0.04c0.01,0.02,0.03,0.05,0.04,0.07c0.01,0.01,0.02,0.03,0.03,0.04
			c0.02,0.02,0.03,0.04,0.05,0.06c0.01,0.01,0.03,0.03,0.04,0.04c0.02,0.02,0.04,0.04,0.05,0.05c0.01,0.01,0.01,0.02,0.02,0.02
			l3.53,3.16c0.25,0.22,0.56,0.34,0.88,0.34c0.36,0,0.72-0.15,0.98-0.44c0.48-0.54,0.44-1.37-0.1-1.85l-0.97-0.87h2.42
			c0.73,0,1.31-0.59,1.31-1.31S14.41,10.89,13.69,10.89z'
        />
        <path
          className='st1'
          fill='#FFFFFF'
          d='M23.16,18.68c0.02-0.02,0.03-0.04,0.05-0.06c0.01-0.02,0.02-0.03,0.03-0.05c0.02-0.02,0.03-0.04,0.04-0.07
			c0.01-0.01,0.02-0.03,0.03-0.04c0.01-0.03,0.03-0.05,0.04-0.08c0.01-0.01,0.01-0.02,0.02-0.04c0.01-0.03,0.03-0.06,0.04-0.09
			c0-0.01,0.01-0.02,0.01-0.03c0.01-0.03,0.02-0.07,0.03-0.11c0-0.01,0-0.02,0.01-0.02c0.01-0.04,0.01-0.08,0.02-0.11
			c0-0.01,0-0.01,0-0.02c0-0.05,0.01-0.09,0.01-0.14s0-0.09-0.01-0.14c0-0.01,0-0.01,0-0.02c0-0.04-0.01-0.08-0.02-0.11
			c0-0.01,0-0.02-0.01-0.02c-0.01-0.04-0.02-0.07-0.03-0.11c0-0.01-0.01-0.02-0.01-0.03c-0.01-0.03-0.02-0.06-0.04-0.09
			c-0.01-0.01-0.01-0.03-0.02-0.04c-0.01-0.03-0.03-0.05-0.04-0.08c-0.01-0.01-0.02-0.03-0.03-0.04c-0.01-0.02-0.03-0.04-0.04-0.07
			c-0.01-0.02-0.02-0.03-0.03-0.05c-0.01-0.02-0.03-0.04-0.05-0.06c-0.01-0.02-0.03-0.03-0.04-0.04c-0.02-0.02-0.03-0.03-0.05-0.05
			c-0.01-0.01-0.02-0.02-0.02-0.02l-3.53-3.16c-0.54-0.48-1.37-0.44-1.85,0.1c-0.48,0.54-0.44,1.37,0.1,1.85l0.97,0.87h-2.42
			c-0.73,0-1.31,0.59-1.31,1.31s0.59,1.31,1.31,1.31h2.42L17.76,20c-0.54,0.48-0.59,1.31-0.1,1.85c0.26,0.29,0.62,0.44,0.98,0.44
			c0.31,0,0.63-0.11,0.88-0.34l3.53-3.16c0.01-0.01,0.02-0.02,0.02-0.02c0.02-0.02,0.03-0.03,0.05-0.05
			C23.13,18.71,23.15,18.69,23.16,18.68z'
        />
      </g>
    </g>
  </svg>
)
export const BenefitsIcon = ({
  width = 40,
  height = 40,
  color = '#C5C5C5',
}: ColorBoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
  >
    <g>
      <circle className='st0' cx='14.96' cy='15.04' r='15' fill={color} />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M14.96,22.46c1.19,0,2.15-0.97,2.15-2.15V17.2h3.11c1.19,0,2.15-0.97,2.15-2.15s-0.97-2.15-2.15-2.15h-3.11
		V9.78c0-1.19-0.97-2.15-2.15-2.15S12.8,8.59,12.8,9.78v3.11H9.69c-1.19,0-2.15,0.97-2.15,2.15s0.97,2.15,2.15,2.15h3.11v3.11
		C12.8,21.49,13.77,22.46,14.96,22.46z'
      />
    </g>
  </svg>
)
export const PerksIcon = ({
  width = 40,
  height = 40,
  color = '#C5C5C5',
}: ColorBoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
  >
    <g>
      <circle className='st0' cx='14.85' cy='15.02' r='15' fill={color} />
      <g>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M19.96,15.38c0-1.72,0-3.42,0-5.18c-1.96,0.41-3.89,0.82-5.84,1.23c0,0.17,0,0.32,0,0.46
			c0,2.34,0,4.68,0,7.02c0,1.32-0.64,2.24-1.9,2.77c-1.22,0.51-2.66,0.27-3.49-0.56c-0.85-0.85-0.86-2.15,0.01-3.07
			c0.9-0.96,2.02-1.28,3.31-1.07c0.06,0.01,0.12,0.02,0.18,0.03c0.01,0,0.02-0.01,0.07-0.02c0-0.12,0-0.25,0-0.38
			c0-1.86,0-3.72,0-5.58c0-0.85,0.21-1.11,1.03-1.29c2.43-0.51,4.86-1.03,7.29-1.54c0.72-0.15,1.21,0.24,1.21,0.97
			c0.01,2.74,0.02,5.49,0,8.23c-0.01,1.46-1.12,2.64-2.6,2.87c-0.95,0.15-1.84,0.02-2.6-0.58c-1.17-0.93-1.08-2.62,0.17-3.61
			C17.64,15.38,18.52,15.18,19.96,15.38z'
        />
      </g>
    </g>
  </svg>
)
export const RibbonIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <g>
        <circle
          className='st0'
          cx='15'
          cy='15'
          r='15'
          fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
        />
      </g>
      <path
        className='st1'
        fill='#FFFFFF'
        d='M19.07,9.27h-8.14c-0.1,0-0.18,0.08-0.18,0.18v11.1c0,0.07,0.04,0.13,0.1,0.16c0.06,0.03,0.13,0.03,0.19-0.01
		L15,17.85l3.97,2.85c0.03,0.02,0.07,0.03,0.11,0.03c0.03,0,0.06-0.01,0.08-0.02c0.06-0.03,0.1-0.09,0.1-0.16V9.45
		C19.25,9.35,19.17,9.27,19.07,9.27z'
      />
    </g>
  </svg>
)
export const EyeIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
    </g>
    <g>
      <path
        className='st1'
        fill='#FFFFFF'
        d='M15,16.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C13.4,15.9,14.1,16.6,15,16.6
		 M5.4,15.8c1.5,1.5,5.2,4.7,9.6,4.7c4.4,0,8.1-3.2,9.6-4.7c0.4-0.4,0.4-1.1,0-1.5c-1.5-1.5-5.2-4.7-9.6-4.7c-4.4,0-8.1,3.2-9.6,4.7
		C5,14.7,5,15.3,5.4,15.8 M15,11.7c1.8,0,3.3,1.5,3.3,3.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3
		C11.7,13.2,13.2,11.7,15,11.7'
      />
    </g>
  </svg>
)
export const EyelashIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
    </g>
    <g>
      <path
        className='st1'
        fill='#FFFFFF'
        d='M15.5,15.8c-4,0-7.3-2.7-8.9-4.3c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0c1.1,1.1,3.9,3.5,7.1,3.5
		c2.5,0,4.6-1.1,6.6-3.5c0.5-0.5,1.2-0.6,1.8-0.1c0.5,0.5,0.6,1.2,0.1,1.8C21.5,14.4,18.7,15.8,15.5,15.8z'
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M5.9,17c-0.3,0-0.5-0.1-0.7-0.2c-0.6-0.4-0.7-1.2-0.3-1.8l2.6-3.7c0.4-0.6,1.2-0.7,1.8-0.3
		c0.6,0.4,0.7,1.2,0.3,1.8l-2.6,3.7C6.6,16.9,6.3,17,5.9,17z'
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M11.9,20.2c-0.1,0-0.2,0-0.3,0c-0.7-0.1-1.1-0.8-1-1.5l0.9-4.6c0.1-0.7,0.8-1.1,1.5-1c0.7,0.1,1.1,0.8,1,1.5
		l-0.9,4.6C13,19.8,12.5,20.2,11.9,20.2z'
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M18.8,20.2c-0.6,0-1.1-0.4-1.2-1l-0.9-4.6c-0.1-0.7,0.3-1.3,1-1.5c0.7-0.1,1.3,0.3,1.5,1l0.9,4.6
		c0.1,0.7-0.3,1.3-1,1.5C19,20.2,18.9,20.2,18.8,20.2z'
      />
      <path
        className='st1'
        fill='#FFFFFF'
        d='M24.9,17c-0.4,0-0.8-0.2-1-0.5l-2.6-3.7c-0.4-0.6-0.3-1.4,0.3-1.8c0.6-0.4,1.4-0.3,1.8,0.3l2.6,3.7
		c0.4,0.6,0.3,1.4-0.3,1.8C25.4,17,25.1,17,24.9,17z'
      />
    </g>
  </svg>
)
export const PeopleIcon = ({
  active = false,
  width = 30,
  height = 30,
  className,
}: BoardIconProps) => (
  <svg
    version='1.1'
    id='Layer_1'
    x='0px'
    y='0px'
    viewBox='0 0 30 30'
    width={width}
    height={height}
    className={className}
  >
    <g>
      <circle
        className='st0'
        cx='15'
        cy='15'
        r='15'
        fill={`${active ? '#7A1AFE' : '#C5C5C5'}`}
      />
    </g>
    <g>
      <g>
        <g>
          <circle className='st1' fill='#FFFFFF' cx='11.8' cy='9.7' r='2.3' />
          <path
            className='st1'
            fill='#FFFFFF'
            d='M11.8,21.6L11.8,21.6c-1.4,0-2.5-1.1-2.5-2.5v-5.5c0-0.3,0.3-0.6,0.6-0.6h3.9c0.3,0,0.6,0.3,0.6,0.6v5.5
				C14.4,20.5,13.2,21.6,11.8,21.6z'
          />
        </g>
        <g>
          <circle className='st1' fill='#FFFFFF' cx='18.4' cy='10.8' r='2.3' />
          <path
            className='st1'
            fill='#FFFFFF'
            d='M18.4,21.6L18.4,21.6c-1.4,0-2.5-1.1-2.5-2.5v-4.4c0-0.3,0.3-0.6,0.6-0.6h3.9c0.3,0,0.6,0.3,0.6,0.6v4.4
				C21,20.5,19.8,21.6,18.4,21.6z'
          />
        </g>
      </g>
    </g>
  </svg>
)
